module.exports = __webpack_public_path__ + "static/media/booking.29d2b48c.svg";